import React from 'react';
import { Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import { auth } from '../../firebase/firebase-config';
import { resolveAuthorColor } from '../../platform/chatAuthorColors';
import { formatAuthorLabel, resolveMessageAuthorName } from '../../platform/displayName';
import ProfileAvatar from './ProfileAvatar';
import './Message.css';

function Message({
  message,
  isAdmin,
  onDelete,
  showAuthorName = true,
  showAuthorAvatar = true,
  isGroupedWithPrevious = false,
  isGroupedWithNext = false,
  authorPhotoURL = '',
  authorColor = '',
  authorDisplayName = '',
}) {
  const { text, createdAt, uid } = message;
  const authorName = formatAuthorLabel(
    authorDisplayName || resolveMessageAuthorName(message) || 'Uporabnik',
  );
  const resolvedAuthorColor = authorColor || resolveAuthorColor(uid, null);
  const messageTime = createdAt ? new Date(createdAt).toLocaleString('sl-SI') : '';
  const isCurrentUser = uid === auth.currentUser?.uid;
  const wrapperClassName = [
    'message-wrapper',
    isCurrentUser ? 'message-wrapper--own' : 'message-wrapper--other',
    isGroupedWithPrevious ? 'message-wrapper--grouped' : '',
    isGroupedWithNext ? 'message-wrapper--grouped-next' : '',
    showAuthorName ? 'message-wrapper--new-sender' : '',
  ].filter(Boolean).join(' ');

  const renderAvatar = () => (
    <ProfileAvatar
      uid={uid}
      photoURL={authorPhotoURL}
      displayName={authorDisplayName || authorName}
      authorColor={resolvedAuthorColor}
      className="message-avatar"
      photoClassName="message-avatar message-avatar--photo"
      initialsClassName="message-avatar"
    />
  );

  return (
    <div className={wrapperClassName}>
      <div className="message-row">
        {!isCurrentUser && (
          showAuthorAvatar ? renderAvatar() : (
            <div className="message-avatar message-avatar--spacer" aria-hidden="true" />
          )
        )}

        <div className="message-stack">
          {!isCurrentUser && showAuthorName && (
            <span className="message-author" style={{ color: resolvedAuthorColor }}>
              {authorName}
            </span>
          )}
          <div className="message-bubble">
            <div className="message-text">{text}</div>
            {messageTime && <time className="message-time">{messageTime}</time>}
          </div>
        </div>
      </div>

      {isAdmin && (
        <Button
          variant="outline-danger"
          size="sm"
          className="message-delete-btn"
          onClick={onDelete}
          aria-label="Izbriši sporočilo"
        >
          <FaTrash />
        </Button>
      )}
    </div>
  );
}

export default Message;
